export default __webpack_public_path__ + "static/media/business-25b.35368974.jpg";